export const ASC = 'asc'
export const DESC = 'desc'
export const NONE = 'none'
